/*
 * PAWS & PEARLS — THE MUSE SECRET SKY — ENCHANTED NIGHT V1.3 MOBILE TEST B — RAPID TWILIGHT / RAPID FIREFLY ARRIVAL
 * 27 Oct 2026 — Jeeves XXVI. Mobile addition to owner-approved desktop V1.2; isolated and reversible.
 * Photography approved 15 original swarms; original sunset image never replaced.
 * The night's source is a colour-grade of THAT EXACT sunset image, not new scenery.
 * Timing: WAIT until Lilla's actual getStatus().phase === 'retreat'.
 * Fallback 48.9 sec after Muse click, from Lilla V1.1 archival stage timing.
 * Lilla, hippo, balloons, sailboats, galleon, clouds, birds and sound untouched.
 * No extra scene, camera offset or scroll changes; ONE overlay inside sky backdrop.
 * Fireflies are behind sky creatures (z-index 1), in front of darkened backdrop.
 * Mobile Test B enables the same night image and time cues for the existing mobile camera.
 */
(function () {
  'use strict';
  var NAMESPACE='ppMuseEnchantedNightV1';
  var SKY_ID='pp-muse-secret-sky';
  var SCENE_CLASS='pp-muse-sky-scene';
  var STAGE_ID='pp-muse-balloon-stage';
  var CONFIG_ID='pp-muse-enchanted-night-assets-v1';
  var NIGHT_ID='pp-muse-enchanted-night-backdrop-v1';
  var SWARM_ID='pp-muse-enchanted-fireflies-v1';
  var STYLE_ID='pp-muse-enchanted-night-v1-style';
  var SRC_WIDTH=1122;
  var SRC_HEIGHT=1402;
  var DUSK_SECONDS=4.5; // Full approved night in 4.5s from Lilla retreat, while The Muse is still flying.
  var SWARM_ONSET_RATIO=0.135; // Keep V1.1 arrival order; compress last start from 23.4s to 3.16s.
  var SWARM_FADE_SECONDS=1.2; // Last arrival complete by ~4.36s.
  var NIGHT_COMPLETE_SECONDS=4.6;
  var FALLBACK_MS=48900;
  // x/y/width are original approved background-artwork coordinates.
  // onset source seconds relative to Lilla's retreat; multiply by SWARM_ONSET_RATIO.
  // Gentle 1.2s individual fade-in; final swarm fully visible by about 4.36 seconds.
  // Corrected for the portion of the painted world visible during the sky visit.
  // All 15 centres now fall between source-artwork y=305 and y=535 (previously 310..1272).
  // x,y,width remain in 1122 x 1402 artwork pixels; preserve original swarm designs.
  var DATA=[
    [8,205,340,218,2.5,0.0],[1,360,405,202,4.8,1.3],
    [12,90,510,226,7.0,2.0],[11,515,455,182,8.0,1.4],
    [3,685,305,219,9.5,2.0],[10,258,532,210,10.7,2.4],
    [5,835,445,220,12.0,0.4],[15,1040,490,182,13.3,0.7],
    [6,435,497,180,14.8,2.6],[13,752,490,280,16.5,1.8],
    [2,1010,510,233,18.0,1.8],[7,610,502,209,19.0,3.0],
    [4,158,510,229,21.0,3.2],[14,868,505,202,22.0,0.6],
    [9,1100,490,235,23.4,2.5]
  ];
  var inst=null;
  if (window[NAMESPACE] && window[NAMESPACE]._ppController === NIGHT_ID) {
    if (window[NAMESPACE].refresh) window[NAMESPACE].refresh();
    return;
  }
  function clamp(v){return Math.max(0,Math.min(1,v));}
  function smooth(v){v=clamp(v);return v*v*(3-2*v);}
  function enabled(){
    var sky=document.getElementById(SKY_ID);
    var wrap=document.querySelector('.page-wrapper');
    return document.documentElement.classList.contains('pp-muse-secret-sky-page') &&
      !!(sky && wrap && wrap.contains(sky) && sky.querySelector('.'+SCENE_CLASS));
  }
  function urlOK(value){return typeof value==='string' && /^(https?:\/\/|\/)/.test(value);}
  function assetUrls(){
    var el=document.getElementById(CONFIG_ID);
    if(!el)return null;
    var a={night:el.getAttribute('data-night')};
    if(!urlOK(a.night)) return null;
    for(var i=1;i<=15;i++){
      var key='swarm'+String(i).padStart(2,'0');
      a[key]=el.getAttribute('data-'+key);
      if(!urlOK(a[key]))return null;
    }
    return a;
  }
  function style(){
    if(document.getElementById(STYLE_ID))return;
    var el=document.createElement('style');el.id=STYLE_ID;
    el.textContent=[
      'html.pp-muse-secret-sky-page #'+SKY_ID+' .'+SCENE_CLASS+' #'+NIGHT_ID+'{position:absolute!important;inset:0!important;pointer-events:none!important;background-position:inherit!important;background-size:inherit!important;background-repeat:no-repeat!important;opacity:0;}',
      'html.pp-muse-secret-sky-page #'+SKY_ID+' #'+SWARM_ID+'{position:absolute!important;inset:0!important;z-index:1!important;pointer-events:none!important;overflow:hidden!important;user-select:none!important;}',
      'html.pp-muse-secret-sky-page #'+SWARM_ID+' .pp-ff-anchor{position:absolute!important;width:0!important;height:0!important;opacity:0;pointer-events:none!important;}',
      'html.pp-muse-secret-sky-page #'+SWARM_ID+' .pp-ff-visual{display:block!important;max-width:none!important;height:auto!important;position:absolute!important;left:0!important;top:0!important;transform:translate(-50%,-50%);opacity:.96;pointer-events:none!important;user-select:none!important;-webkit-user-drag:none!important;}',
      'html.pp-muse-secret-sky-page #'+SWARM_ID+' .pp-ff-anchor.pp-ff-active{animation:pp-ff-orbit-v1-1 var(--pp-ff-period,19s) linear infinite;animation-delay:var(--pp-ff-delay,0s);animation-direction:var(--pp-ff-direction,normal);}',
      'html.pp-muse-secret-sky-page #'+SWARM_ID+' .pp-ff-anchor.pp-ff-active img{animation:pp-ff-pulse-v1 var(--pp-ff-pulse,5.7s) ease-in-out infinite;animation-delay:var(--pp-ff-delay,0s);}',
      '@keyframes pp-ff-orbit-v1-1{0%,100%{transform:translate3d(var(--pp-ff-rx,11px),0,0)}12.5%{transform:translate3d(var(--pp-ff-ax,8px),var(--pp-ff-ay,5px),0)}25%{transform:translate3d(0,var(--pp-ff-ry,7px),0)}37.5%{transform:translate3d(var(--pp-ff-nax,-8px),var(--pp-ff-ay,5px),0)}50%{transform:translate3d(var(--pp-ff-nrx,-11px),0,0)}62.5%{transform:translate3d(var(--pp-ff-nax,-8px),var(--pp-ff-nay,-5px),0)}75%{transform:translate3d(0,var(--pp-ff-nry,-7px),0)}87.5%{transform:translate3d(var(--pp-ff-ax,8px),var(--pp-ff-nay,-5px),0)}}',
      '@keyframes pp-ff-pulse-v1{0%,100%{filter:brightness(.90)}45%{filter:brightness(1.06)}78%{filter:brightness(.95)}}',
      '@media(prefers-reduced-motion:reduce){html.pp-muse-secret-sky-page #'+SWARM_ID+' .pp-ff-anchor,html.pp-muse-secret-sky-page #'+SWARM_ID+' .pp-ff-visual{animation:none!important;transition:none!important;}}'
    ].join('');
    document.head.appendChild(el);
  }
  function kill(){
    if(!inst)return;
    inst.dead=true;
    if(inst.raf)cancelAnimationFrame(inst.raf);
    if(inst.ro)inst.ro.disconnect();
    if(inst.io)inst.io.disconnect();
    document.removeEventListener('visibilitychange',inst.vis);
    window.removeEventListener('resize',inst.resize);
    if(inst.motion){
      if(inst.motion.removeEventListener)inst.motion.removeEventListener('change',inst.change);
      else if(inst.motion.removeListener)inst.motion.removeListener(inst.change);
    }
    if(inst.night)inst.night.remove();
    if(inst.layer)inst.layer.remove();
    inst=null;
  }
  function geometry(p){
    // Desktop retains the original V1.2 artwork positioning exactly.
    // Mobile scene is a portrait artwork cropped by background-size: cover.
    // Map the firefly artwork coordinates through that SAME cover transform
    // so their centres track the night painting (instead of being misplaced).
    var rect=p.scene.getBoundingClientRect();
    var w=rect.width||p.scene.clientWidth;
    var h=rect.height||p.scene.clientHeight;
    var mobile=window.matchMedia('(max-width: 767px)').matches;
    var scale=mobile?Math.max(w/SRC_WIDTH,h/SRC_HEIGHT):w/SRC_WIDTH;
    var offsetX=mobile?(w-SRC_WIDTH*scale)/2:0;
    var offsetY=mobile?(h-SRC_HEIGHT*scale)/2:0;
    if(!isFinite(scale)||scale<=0)return;
    p.scale=scale;
    p.boats.forEach(function(x){
      x.el.style.left=(offsetX+x.data[1]*scale).toFixed(2)+'px';
      x.el.style.top=(offsetY+x.data[2]*scale).toFixed(2)+'px';
      x.img.style.width=(x.data[3]*scale).toFixed(2)+'px';
      // A tiny ellipse rather than linear sway. Vary radius by swarm for organic movement.
      // Deliberately no rotation: photography's artwork keeps its original orientation.
      var rx=(9.3+(x.data[0]%4)*1.65)*scale;
      var ry=(4.9+(x.data[0]%3)*1.35)*scale;
      var shape=[['--pp-ff-rx',rx],['--pp-ff-ry',ry],['--pp-ff-nrx',-rx],['--pp-ff-nry',-ry],
        ['--pp-ff-ax',rx*.7071],['--pp-ff-ay',ry*.7071],['--pp-ff-nax',-rx*.7071],['--pp-ff-nay',-ry*.7071]];
      shape.forEach(function(v){x.el.style.setProperty(v[0],v[1].toFixed(2)+'px');});
    });
  }
  function reset(p){
    p.pending=true;p.running=false;p.completed=false;p.elapsed=0;p.waitMs=0;
    p.stamp=0;p.phase='waiting-for-Lilla';
    p.night.style.opacity='0';
    p.boats.forEach(function(x){x.el.style.opacity='0';x.el.classList.remove('pp-ff-active');});
  }
  function setTimeline(p,t){
    var dark=Math.pow(smooth(t/DUSK_SECONDS),.72);
    p.night.style.opacity=dark.toFixed(4);
    var active=0;
    p.boats.forEach(function(x){
      var a=smooth((t-x.data[4]*SWARM_ONSET_RATIO)/SWARM_FADE_SECONDS);
      x.el.style.opacity=(a*.9).toFixed(4);
      if(a>0.002){ active++;if(!p.reduced)x.el.classList.add('pp-ff-active'); }
    });
    p.active=active;
    if(t>=NIGHT_COMPLETE_SECONDS){p.completed=true;p.running=false;p.phase='enchanted-night';}
  }
  function seekRetreat(){
    try {
      var api=window.ppMuseLillaZebraV1;
      if(api && typeof api.getStatus==='function'){
        var st=api.getStatus();
        return st && st.active && st.phase==='retreat';
      }
    }catch(_){ }
    return false;
  }
  function motionFrame(now){
    if(!inst||inst.dead)return;
    var p=inst;
    p.raf=0;
    if(!p.sky.isConnected){kill();return;}
    if(document.hidden)return;
    if(!enabled()){kill();return;}
    if(p.pending){
      if(seekRetreat() || now-p.flightStart>=FALLBACK_MS){
        p.pending=false;p.running=true;p.phase='dusk';p.elapsed=0;p.stamp=now;
      }
    }else if(p.running && !p.reduced){
      if(p.stamp)p.elapsed+=Math.min(100,Math.max(0,now-p.stamp));
      p.stamp=now;
      setTimeline(p,p.elapsed/1000);
    }else if(p.running && p.reduced){
      // Respect visitor motion preference: switch to a nonanimated night scene.
      p.elapsed=NIGHT_COMPLETE_SECONDS*1000;setTimeline(p,NIGHT_COMPLETE_SECONDS);
    }
    if(p.pending||p.running)p.raf=requestAnimationFrame(motionFrame);
  }
  function refresh(){
    if(!enabled()){kill();return;}
    var sky=document.getElementById(SKY_ID),scene=sky.querySelector('.'+SCENE_CLASS);
    if(inst&&inst.sky===sky&&inst.night.isConnected&&inst.layer.isConnected){geometry(inst);return;}
    kill();
    var urls=assetUrls();if(!urls){console.warn('[P&P Enchanted Night] Missing asset URLs, no changes made.');return;}
    style();
    var night=document.createElement('div');night.id=NIGHT_ID;night.setAttribute('aria-hidden','true');
    night.style.backgroundImage='url("'+urls.night.replace(/"/g,'%22')+'")';
    scene.appendChild(night);
    var layer=document.createElement('div');layer.id=SWARM_ID;layer.setAttribute('aria-hidden','true');
    var boats=[];
    DATA.forEach(function(data){
      var num=String(data[0]).padStart(2,'0');
      var node=document.createElement('span');node.className='pp-ff-anchor';node.setAttribute('data-swarm',num);
      node.style.setProperty('--pp-ff-period',(16.5+(data[0]%6)*2.2)+'s');
      node.style.setProperty('--pp-ff-pulse',(4.3+(data[0]%5)*.77)+'s');
      node.style.setProperty('--pp-ff-delay',(-data[5]*3.7)+'s');
      node.style.setProperty('--pp-ff-direction',(data[0]%2===0?'reverse':'normal'));
      var img=document.createElement('img');img.className='pp-ff-visual';img.alt='';img.draggable=false;
      img.loading='lazy';img.decoding='async';img.src=urls['swarm'+num];
      node.appendChild(img);layer.appendChild(node);boats.push({el:node,img:img,data:data});
    });
    // Insert BEFORE the existing foreground visual layers at the same z-index.
    sky.insertBefore(layer,scene.nextSibling);
    var p={sky:sky,scene:scene,night:night,layer:layer,boats:boats,raf:0,io:null,ro:null,
      scale:1,pending:false,running:false,completed:false,elapsed:0,active:0,phase:'day',
      flightStart:0,stamp:0,dead:false,reduced:false,motion:null,vis:null,resize:null,change:null};
    inst=p;
    p.motion=window.matchMedia('(prefers-reduced-motion: reduce)');p.reduced=p.motion.matches;
    geometry(p);
    p.vis=function(){if(!document.hidden && (p.pending||p.running) && !p.raf){p.stamp=0;p.raf=requestAnimationFrame(motionFrame);}};
    p.resize=function(){if(!enabled()){kill();return;}geometry(p);};
    p.change=function(ev){p.reduced=ev.matches;if(p.running&&!p.raf)p.raf=requestAnimationFrame(motionFrame);};
    document.addEventListener('visibilitychange',p.vis);
    window.addEventListener('resize',p.resize,{passive:true});
    if(p.motion.addEventListener)p.motion.addEventListener('change',p.change);
    else if(p.motion.addListener)p.motion.addListener(p.change);
    if('ResizeObserver' in window){p.ro=new ResizeObserver(function(){geometry(p);});p.ro.observe(sky);}
  }
  function onMuseFlight(e){
    var hit=e.target&&e.target.closest&&e.target.closest('#'+STAGE_ID+' .pp-balloon, .pp-muse-flight-overlay.pp-balloon');
    if(!hit)return;
    refresh();if(!inst)return;
    reset(inst);inst.flightStart=performance.now();
    if(!inst.raf)inst.raf=requestAnimationFrame(motionFrame);
  }
  function removeOnSectionUnload(e){
    if(inst&&e.target&&(e.target===inst.sky||e.target.contains(inst.sky)))kill();
  }
  // Expose read-only diagnostics plus an explicit PREVIEW switch for dry runs in draft theme.
  // Demo does NOT trigger The Muse or alter other controllers.
  window[NAMESPACE]={_ppController:NIGHT_ID,refresh:refresh,getStatus:function(){return {
    version:'1.3-mobile-night-test',nightfallSeconds:DUSK_SECONDS,swarmArrivalSeconds:4.4,swarmMovement:'subtle individual elliptical drift',
    present:!!(inst&&inst.layer&&inst.layer.isConnected),phase:inst?inst.phase:'not-mounted',
    waitingForRetreat:!!(inst&&inst.pending),nightLevel:inst?Number(inst.night.style.opacity||0):0,
    visibleSwarms:inst?inst.active:0,displayMode:'desktop-and-mobile',
    changesMuseFlight:false,changesSound:false
  };},previewNight:function(){refresh();if(!inst)return;reset(inst);inst.pending=false;inst.running=true;inst.phase='dusk';inst.stamp=0;if(!inst.raf)inst.raf=requestAnimationFrame(motionFrame);},resetDay:function(){refresh();if(inst){reset(inst);inst.pending=false;inst.phase='day';if(inst.raf){cancelAnimationFrame(inst.raf);inst.raf=0;}}}};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh,{once:true});
  else refresh();
  document.addEventListener('click',onMuseFlight,false);
  document.addEventListener('shopify:section:load',refresh);
  document.addEventListener('shopify:section:unload',removeOnSectionUnload);
  window.addEventListener('pageshow',refresh);
  // Re-enable draft preview after switching from a narrow/mobile viewport back to desktop.
  window.addEventListener('resize',refresh,{passive:true});
})();
